// extracted by mini-css-extract-plugin
module.exports = {"root":"K-uxm","content-wrapper":"_3I6Uf","contentWrapper":"_3I6Uf"};